import { useEffect } from "react";

const AdBanner = () => {
  useEffect(() => {
    try {
      if (window.adsbygoogle) {
        window.adsbygoogle.push({});
      }
    } catch (err) {
      console.log(err);
    }
  }, []);

  return (
    <ins
      className="adsbygoogle"
      style={{ display: "block" }}
      data-ad-client="ca-pub-2265340058970791"
      data-ad-slot="8180531471"
      data-ad-format="auto"
      data-full-width-responsive="true"
    />
  );
};

export default AdBanner;